/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyHistory from './pharmacy-history';
import PharmacyHistoryDetail from './pharmacy-history-detail';
import PharmacyHistoryUpdate from './pharmacy-history-update';
import PharmacyHistoryDeleteDialog from './pharmacy-history-delete-dialog';

const PharmacyHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyHistory />} />
    <Route path="new" element={<PharmacyHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyHistoryDetail />} />
      <Route path="edit" element={<PharmacyHistoryUpdate />} />
      <Route path="delete" element={<PharmacyHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyHistoryRoutes;
